export function removeTrailingComma(str: string) {
    const trimmedStr = str.trim();
    return trimmedStr.endsWith(',') ? trimmedStr.slice(0, -1) : str;
  }